var r={rtl:"frz7f",ltr:"AnCKd"};export{r as b};
//# sourceMappingURL=rtl.rtlignore-0066ee65.js.map
